import { Construction } from 'lucide-react';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function StartupHomePage(): JSX.Element {
  return (
    <StartupSubPageShell activeSection="home">
      {() => (
        <section className="mx-auto w-full max-w-5xl px-6 py-10">
          <header className="mb-6">
            <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Home</h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Your startup overview, at a glance.
            </p>
          </header>

          <div className="bg-surface rounded-2xl border border-gray-100 dark:bg-gray-800 dark:border-gray-700">
            <div className="text-center py-16 px-6">
              <Construction className="w-10 h-10 text-gray-300 dark:text-gray-600 mx-auto mb-3" />
              <p className="text-sm text-gray-500 dark:text-gray-400">
                The Home dashboard will be available soon.
              </p>
            </div>
          </div>
        </section>
      )}
    </StartupSubPageShell>
  );
}
